import { useState, useEffect } from "react";
import { CheckCompany, CheckOnboardingIssue, CheckResponseError, Workspace, CheckSignatory, isCheckError } from "winslow-core";
import { Button, Label, Alert, AlertDescription } from "../../../ds2/components";
import { apiCheckGetCompany, apiCheckGetCompanyFilingComponent } from "../../../services/PayrollService";
import { CheckEmbeddedComponentV2 } from "../../payroll/CheckEmbeddedComponentV2";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import "./AppPayFilingAuthorization.css";

type AppPayFilingAuthorizationProps = {
    checkCompany: CheckCompany | null;
    workspace: Workspace | null;
    checkSignatories: CheckSignatory[] | null;
    loadingFilingAuthorization: boolean;
    // onViewForm: (filingAuthorization: CheckOnboardingIssue) => void;
    // onEditForm: (filingAuthorization: CheckOnboardingIssue) => void;
    // onEmbedForm: () => void;
    // onCheckCompanyUpdated: (checkCompany: CheckCompany) => void;
    onComplete?: () => void;
    onError?: (error: CheckResponseError | undefined) => void;
};

export const AppPayFilingAuthorization = ({
    checkCompany,
    workspace,
    checkSignatories,
    loadingFilingAuthorization,
    // onViewForm,
    // onEditForm,
    // onEmbedForm,
    // onCheckCompanyUpdated,
    onComplete,
    onError,
}: AppPayFilingAuthorizationProps) => {
    const [componentUrl, setComponentUrl] = useState<string | null>(null);
    const [loadingComponent, setLoadingComponent] = useState<boolean>(false);
    const [checkResponseError, setCheckResponseError] = useState<CheckResponseError | undefined>(undefined);

    const hasFilingAuthorizations = checkCompany?.onboard?.filing_authorization && checkCompany.onboard.filing_authorization.length > 0;

    // Load component URL when filing authorizations exist
    useEffect(() => {
        if (hasFilingAuthorizations && checkCompany && checkSignatories && checkSignatories.length > 0) {
            loadComponentUrl();
        } else {
            setComponentUrl(null);
            setCheckResponseError(undefined);
        }
    }, [hasFilingAuthorizations, checkCompany, checkCompany?.onboard?.filing_authorization, checkSignatories]);

    const loadComponentUrl = async () => {
        if (!checkCompany?.id || !checkSignatories || checkSignatories.length === 0) {
            return;
        }

        const firstSignatory = checkSignatories[0];
        if (!firstSignatory?.id) {
            return;
        }

        setLoadingComponent(true);
        setCheckResponseError(undefined);

        try {
            const apiResponse = await apiCheckGetCompanyFilingComponent(checkCompany.id, firstSignatory.id);
            const url = apiResponse?.data;
            setCheckResponseError(apiResponse?.checkResponseError);

            if (apiResponse?.checkResponseError && onError) {
                onError(apiResponse.checkResponseError);
            }

            if (!apiResponse || isCheckError(apiResponse) || !url) {
                toast("Error loading filing component", toastFail);
                return;
            }

            setComponentUrl(url);
        } catch (error) {
            console.error("[AppPayFilingAuthorization] Error loading component URL:", error);
            toast("Error loading filing component", toastFail);
        } finally {
            setLoadingComponent(false);
        }
    };

    // const refreshCheckCompany = async () => {
    //     if (workspace?.company?.checkCompanyId) {
    //         const apiResponseCompany = await apiCheckGetCompany(workspace.company.checkCompanyId);
    //         if (apiResponseCompany?.data) {
    //             onCheckCompanyUpdated(apiResponseCompany.data);
    //         }
    //     }
    // };

    return (
        <div className="app-pay-filing-authorization-contents">
            <div className="app-pay-filing-authorization-left">
                <Label>
                    Filing Authorization
                </Label>
                {loadingFilingAuthorization && (
                    <div style={{ marginTop: "16px" }}>
                        Loading filing authorization...
                    </div>
                )}
                {!loadingFilingAuthorization && (
                    <>
                        {checkResponseError && (
                            <Alert variant="warning" style={{ marginTop: "16px", marginBottom: "16px" }}>
                                <AlertDescription>
                                    {checkResponseError.errorMessage || "An error occurred"}
                                </AlertDescription>
                            </Alert>
                        )}
                        {hasFilingAuthorizations ? (
                            <>
                                {!checkSignatories || checkSignatories.length === 0 ? (
                                    <Alert variant="warning" style={{ marginTop: "16px" }}>
                                        <AlertDescription>
                                            No valid signatory
                                        </AlertDescription>
                                    </Alert>
                                ) : loadingComponent ? (
                                    <div style={{ marginTop: "16px", padding: "40px", textAlign: "center" }}>
                                        Loading filing component...
                                    </div>
                                ) : componentUrl ? (
                                    <div className="app-pay-enroll-embed" style={{ marginTop: "16px" }}>
                                        <CheckEmbeddedComponentV2
                                            url={componentUrl}
                                            title="Filing Authorization"
                                            onEvent={(event, data) => {
                                                console.log("[AppPayFilingAuthorization] Check component event:", event, data);
                                                // Call onComplete when component completes
                                                if (event === "check-component-company-filing-authorization-complete" || 
                                                    event === "check-component-company-filing-authorization-already-complete") {
                                                    if (onComplete) {
                                                        onComplete();
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                ) : (
                                    <Alert variant="warning" style={{ marginTop: "16px" }}>
                                        <AlertDescription>
                                            Component not found.
                                        </AlertDescription>
                                    </Alert>
                                )}
                            </>
                        ) : (
                            <div style={{ marginTop: "16px" }}>
                                No filing authorizations found.
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

